export default "__VITE_ASSET__2LpMf4DR__"